import styled from 'styled-components'

import { Button } from '@ucheba/ui/components/Button/desktop'

export const Container = styled.div`
  display: flex;
  column-gap: 24px;
  justify-content: space-between;
`

export const ContainerTouch = styled.div`
  display: flex;
  column-gap: 24px;
  flex-direction: column;
`

export const Content = styled.div`
  display: flex;
  flex-direction: column;
`

export const ButtonStyled = styled(Button)`
  width: 240px;
  margin-top: auto;
`

export const Image = styled.img`
  height: 207px;
  margin: auto 0 auto auto;
`

export const ImageTouch = styled.img`
  margin: auto;
  width: 170px;
  height: 165px;
`
